import React from 'react';

export default function Logo() {
  return (
    <span style={{fontFamily: `'Pacifico', cursive`}} className="text-2xl">
      mockapi.io
    </span>
  );
}
